<div class="content-header">
    <h2>Expediente Electrónico</h2>
</div>
@if(loadingInicio){
<div class="loading-overlay">
    <div class="loading-indicator">Cargando expedientes...</div>
</div>
}

<div class="expediente-filter-bar">
    <!-- <div class="filter-group">
        <label for="filtro-general">Filtro general:</label>
        <div class="input-wrapper">
            <i class="fas fa-search icon"></i>
            <input type="text" id="filtro-general" placeholder="">
        </div>
    </div> -->
    <div class="filter-group">
        <label for="filtro-expediente">Filtrar:</label>
        <div class="input-wrapper">
            <i class="fas fa-search icon"></i>
            <input type="text" id="filtro-expediente" placeholder="" (ngModelChange)="buscar($event)"
                [(ngModel)]="filter">
        </div>
    </div>
</div>

@if(datos){
<div class="table-controls">
    <label>
        Elementos por página:
        <select [value]="pageSize" [(ngModel)]="pageSize" (change)="actualizaLista()">
            @for(size of pageSizes; track $index) {
            <option [value]="size">{{ size }}</option>
            }

        </select>
    </label>
    @if(filter && filter.trim() !==''){
    <oaj-exportar-excel [columns]="columnasReporte" [fileName]="'Reporte Expediente Electrónico.xlsx'"
        [data]="(datos | async) ?? []" [supertitle]="nombreAutoridad">
    </oaj-exportar-excel>
    }
    @else {
    <oaj-exportar-excel [columns]="columnasReporte" [fileName]="'Reporte Expediente Electrónico.xlsx'"
        (emitExport)="busquedaCompletaExportar()" [useEmitter]="true" [supertitle]="nombreAutoridad">
    </oaj-exportar-excel>
    }
</div>
}


<oaj-alert-itx></oaj-alert-itx>
<div class="table-container">
    <table>
        <thead>
            <tr>
                <th>Ver</th>
                <th>NEUN</th>
                <th>Expediente</th>
                <th>Tipo de Asunto</th>
                <th>Órgano Jurisdiccional PJF</th>
                <th>Circuito</th>
            </tr>
        </thead>
        <tbody>
            @for (item of (datos | async); track item.neun) {
            <tr>
                <td>
                    <button class="icon-button" [disabled]="item.loading"
                        (click)="fnAperturaEE_Ebook(item,'ExpElectronicoModal')">
                        @if(!item.loading) {
                        <i class="fas fa-book-open icon"></i>
                        }
                        @else {
                        <i class="fas fa-spinner fa-spin"></i>
                        }
                    </button>
                </td>
                <td>
                    {{ item.neun }}
                </td>
                <td>
                    {{item.expediente}}
                </td>
                <td>
                    {{item.tipoAsunto}}
                </td>
                <td>
                    {{item.organoJuridisccional}}
                </td>
                <td>
                    {{item.circuito}}
                </td>
            </tr>
            }
            <!-- <tr>
                <td><i class="fas fa-file-alt table-icon"></i></td>
                <td>00000</td>
                <td>A0000000000</td>
                <td>Amparo directo</td>
                <td>Juzgado Tercero de distrito en materia administrativa Civil y de trabajo en el estado de Jalisco
                </td>
                <td>A000000000</td>
            </tr> -->

        </tbody>
    </table>
</div>

<div class="pagination">
    <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="collectionSize" (pageChange)="buscar('')" />
</div>



<!-- Modal Previo-->
<div class="modal fade" id="ExpElectronicoModal" tabindex="-1" aria-labelledby="ExpElectronicoModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-fullscreen custom-size">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="ExpElectronicoModalLabel">Expediente Electrónico</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                @if(isCompletedEE){
                <lib-oaj-expediente-electronico [request]="_Record"></lib-oaj-expediente-electronico>
                }

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>